import * as React from 'react';
import { trackView } from '../../services/analytics';
import Render from './render';

class LeadershipPage extends React.Component<any> {
  componentDidMount() {
    trackView(this.props.location.pathname);
  }

  render() {
    return Render.call(this, this.props, this.state);
  }
}

export default LeadershipPage;



// WEBPACK FOOTER //
// ./src/containers/Leadership/index.tsx